module.exports = __webpack_public_path__ + "img/tiktok.6e085bd2.svg";